import script from "./CenterMap.vue?vue&type=script&setup=true&lang=ts"
export * from "./CenterMap.vue?vue&type=script&setup=true&lang=ts"

import "./CenterMap.vue?vue&type=style&index=0&id=063c825d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-063c825d"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
